/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import { AnimatePresence, motion } from "framer-motion";

import { DragCanvasSession, Session } from "src/classes/plate/Session";
import { SessionType } from "src/classes/plate/Session/session.types";
import { PositionUtils } from "src/classes/utilities/PositionUtils";
import { StyledData } from "src/components/Plate/Data/styles";

interface Props {
  session: Session | null;
}
export function DimensionsWrapper({ session }: Props) {
  const isVisible = !!session && session.snapshot.type === SessionType.DragCanvas;
  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div exit={{ opacity: 0 }}>
          <Dimensions session={session as DragCanvasSession} />
        </motion.div>
      )}
    </AnimatePresence>
  );
}

function Dimensions({ session }: { session: DragCanvasSession }) {
  const anchorY = session.observe((state) => state.anchor.y); // must observe individually to trigger rerender (objects have reference equality)
  const anchorX = session.observe((state) => state.anchor.x);
  const focusY = session.observe((state) => state.focus.y);
  const focusX = session.observe((state) => state.focus.x);
  const { width, height } = PositionUtils.getCSSPositionFromPoints(
    { x: anchorX, y: anchorY },
    { x: focusX, y: focusY }
  );
  return <StyledData>{`${PositionUtils.snapToGrid(width)} x ${PositionUtils.snapToGrid(height)}`}</StyledData>;
}
